import { render } from "./card.vue?vue&type=template&id=408b42d4&scoped=true&ts=true"
import script from "./card.vue?vue&type=script&lang=ts"
export * from "./card.vue?vue&type=script&lang=ts"

import "./card.vue?vue&type=style&index=0&id=408b42d4&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408b42d4"]])

export default __exports__